import Navbar from "../Navbar/Navbar";
import SidebarNav from "./SidebarNav";
import { closeSidebar as closeMobileSidebar } from "../utils/sidebarMobile";

/**
 * Meta-style app shell: full-width top bar + light sidebar + gray content area.
 */
export default function AppShell({ children, sidebarHeader, menuGroups, sidebarFooter }) {
  const closeSidebar = () => {
    closeMobileSidebar();
  };

  return (
    <div className="nf-app-shell">
      <header className="nf-topbar">
        <Navbar />
      </header>
      <div className="nf-app-body">
        <div
          className="sidebar-backdrop"
          onClick={closeSidebar}
          aria-hidden="true"
        />
        <aside
          className="sidenav navbar navbar-vertical navbar-expand-xs"
          id="sidenav-main"
        >
          <button
            type="button"
            className="nf-sidebar-close-mobile d-xl-none"
            onClick={closeSidebar}
            aria-label="Close menu"
          >
            <i className="fas fa-times" aria-hidden="true" />
          </button>
          <div className="sidenav-header nf-sidenav-header--hidden">
            <i
              className="fas fa-times p-3 cursor-pointer position-absolute end-0 top-0 d-none d-xl-none nf-sidebar-close"
              aria-hidden="true"
              id="iconSidenav"
              onClick={closeSidebar}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === "Enter" && closeSidebar()}
            />
            {sidebarHeader}
          </div>
          <div
            className="collapse navbar-collapse w-auto show nf-sidebar-nav-wrap"
            id="sidenav-collapse-main"
          >
            <SidebarNav groups={menuGroups} onNavigate={closeSidebar} />
          </div>
          {sidebarFooter ? <div className="nf-sidebar-footer">{sidebarFooter}</div> : null}
        </aside>
        <main className="main-content position-relative">
          <div className="nf-page-content container-fluid">{children}</div>
        </main>
      </div>
    </div>
  );
}
